module.exports = __webpack_public_path__ + "static/media/text-content.b8c821a3.png";